import { useMediaQuery } from 'react-responsive';

export const MEDIA_BREAKPOINTS = {
    desktop: { minWidth: 1025 },
    aboveMobile: { minWidth: 601 },
    belowDesktop: { maxWidth: 1024 },
    tablet: { maxWidth: 1024, minWidth: 768 },
    mobile: { maxWidth: 600 },
};

export function useBreakpoints() {
    const isDesktop = useMediaQuery(MEDIA_BREAKPOINTS['desktop']);
    const isAboveMobile = useMediaQuery(MEDIA_BREAKPOINTS['aboveMobile']);
    const isBelowDesktop = useMediaQuery(MEDIA_BREAKPOINTS['belowDesktop']);
    const isTablet = useMediaQuery(MEDIA_BREAKPOINTS['tablet']);
    const isMobile = useMediaQuery(MEDIA_BREAKPOINTS['mobile']);

    return { isDesktop, isAboveMobile, isBelowDesktop, isTablet, isMobile };
}

export const useIsMobile = () => {
    return !!useMediaQuery(MEDIA_BREAKPOINTS['mobile']);
};

export const useIsDesktop = () => {
    return !!useMediaQuery(MEDIA_BREAKPOINTS['desktop']);
};
